// Redux actions for SocketMessage handling

export const SET_SOCKET_MESSAGE = 'SET_SOCKET_MESSAGE';
export const CLEAR_SOCKET_MESSAGE = 'CLEAR_SOCKET_MESSAGE';
export const SET_SOCKET_MESSAGE_ERROR = 'SET_SOCKET_MESSAGE_ERROR';
export const SET_EXCHANGE_MESSAGE = 'SET_EXCHANGE_MESSAGE';
export const CLEAR_EXCHANGE_MESSAGES = 'CLEAR_EXCHANGE_MESSAGES';

// Action to set socket message
export const setSocketMessageAction = (messageData) => ({
  type: SET_SOCKET_MESSAGE,
  payload: messageData
});

// Action to clear socket message
export const clearSocketMessageAction = () => ({
  type: CLEAR_SOCKET_MESSAGE
});

// Action to set socket message error
export const setSocketMessageErrorAction = (error) => ({
  type: SET_SOCKET_MESSAGE_ERROR,
  payload: error
});

// Action to set exchange-specific message
export const setExchangeMessageAction = (exchange, messageData) => ({
  type: SET_EXCHANGE_MESSAGE,
  payload: { exchange, messageData }
});

// Action to clear exchange messages
export const clearExchangeMessagesAction = (exchange = null) => ({
  type: CLEAR_EXCHANGE_MESSAGES,
  payload: exchange // null means clear all exchanges
});

const getSessionTime = (message) => String(message?.currentSession?.[0]?.sessionTime ?? '').trim().replace(/\s+/g, ' ');

export const canShowExchangeMessage = (message) =>
  message?.marketStatus === 'Open' &&
  Boolean(message?.genericMessage || message?.bodMessage || message?.holidayMessage);

// Same exchange and same sessionTime means both frames are the same notification,
// e.g. its Closed frame sent when the session ends
const isSameExchangeMessage = (a, b) =>
  Boolean(a && b) && a.exchange === b.exchange && getSessionTime(a) === getSessionTime(b);

// Enhanced async action to process and store socket message
export const processSocketMessageAction = (message) => {
  return (dispatch, getState) => {
    try {
      console.log('📨 Processing SocketMessage for Redux:', message);

      // Store the message with enhanced timestamp
      const processedMessage = {
        ...message,
        receivedAt: new Date().toISOString(),
        timestamp: message.timestamp || Date.now(),
        id: `${message.exchange}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };

      // Store in general socket message store
      dispatch(setSocketMessageAction(processedMessage));

      // Store in exchange-specific store if exchange is specified
      if (message?.exchange) {
        const storedMessage = getState().socketMessage?.exchangeMessages?.[message.exchange]?.currentMessage;
        // Replace only with an update of the stored notification (same sessionTime, e.g. its Closed
        // frame) or with one that can be shown, so unrelated frames can't wipe the shown notification
        if (isSameExchangeMessage(storedMessage, processedMessage) || canShowExchangeMessage(processedMessage)) {
          dispatch(setExchangeMessageAction(message.exchange, processedMessage));
        }
      }


      // Special handling for MCX margin messages
      if (message?.exchange === 'MCX' &&
        (message?.genericMessage?.includes('special/additional margin calculation') ||
          message?.bodMessage?.includes('special/additional margin calculation'))) {
        console.log('🎯 MCX Special Margin Message received:', {
          exchange: message.exchange,
          marketStatus: message.marketStatus,
          sessionTime: message.currentSession?.[0]?.sessionTime,
          marginMessage: message.genericMessage || message.bodMessage
        });
      }

    } catch (error) {
      console.error('❌ Error processing SocketMessage:', error);
      dispatch(setSocketMessageErrorAction(error.message));
    }
  };
}; 